import { useCallback, useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useModals, ModalNames } from 'components/modals';
import useUI from 'hooks/use-ui';
import { InterfaceVariants } from 'src/constants/interface-variants';

const EXCLUDED_VARIANTS: InterfaceVariants[] = [
  InterfaceVariants.kiosk,
  InterfaceVariants.mobileEcomm,
  InterfaceVariants.plus,
];

export type TriggerPostSignupModalSequenceParams = {
  skipPostSignupSequence?: boolean;
};

export type UsePostSignupModalSequenceResult = {
  triggerPostSignupModalSequence: (params?: TriggerPostSignupModalSequenceParams) => Promise<void>;
};

export function usePostSignupModalSequence(): UsePostSignupModalSequenceResult {
  const { openModal } = useModals();
  const flags = useFlags();
  const { variant } = useUI();
  const isRolloutEnabled = flags['fintech.platform.post-signup-onboarding-modals.rollout'] ?? false;

  const triggerPostSignupModalSequence = useCallback(
    async ({ skipPostSignupSequence = false }: TriggerPostSignupModalSequenceParams = {}): Promise<void> => {
      if (skipPostSignupSequence || !isRolloutEnabled || EXCLUDED_VARIANTS.includes(variant)) {
        return;
      }

      await openModal(ModalNames.postSignupLoyaltyJoin);
      await openModal(ModalNames.postSignupBankLink);
      await openModal(ModalNames.postSignupLoyaltyPass);
    },
    [openModal, isRolloutEnabled, variant]
  );

  return useMemo(() => ({ triggerPostSignupModalSequence }), [triggerPostSignupModalSequence]);
}
